import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"

const FormButtons = props => {
  const [activeTab, setactiveTab] = useState(1)
  const [loading, setloading] = useState(false)

  useEffect(() => {
    //console.log("props " , props)
    setactiveTab(props.activeTab)
  }, [props.activeTab])

  useEffect(() => {
    //console.log("props " , props)
    setloading(props.loading)
  }, [props.loading])
  return (
    <div className="actions clearfix">
      <ul>
        <li>
          <Link
            to="#"
            className={
              activeTab === 1 ? "btn btn-primary disabled" : "btn btn-primary"
            }
            onClick={() => {
              props.togglePrevious()
            }}
          >
            Previous
          </Link>
        </li>
        <li>
          <Link
            to="#"
            className={
              activeTab === 3 ? "btn btn-primary disabled" : "btn btn-primary"
            }
            onClick={() => {
              // if (activeTab === 1) {
              //   exportFormRef.current.click()
              // } else if (activeTab === 2) {
              //   toggleTab(activeTab + 1)
              // } else {
              //   toggleTab(activeTab + 1)
              // }
              props.toggleNext()
            }}
          >
            Next
          </Link>
        </li>
        {activeTab === 3 ? (
          <li style={{ float: "right" }}>
            {loading ? (
              <Link
                to="#"
                className="spinner-border text-info"
              />
            ) : (
              <Link
                to="#"
                className="btn btn-primary"
                onClick={() => {
                  props.toggleSubmit()
                }}
                //disabled
              >
                Submit
              </Link>
            )}
          </li>
        ) : (
          ""
        )}
      </ul>
    </div>
  )
}

export default FormButtons
